<template>
  <v-dialog v-model="modalAberto" transition="dialog-bottom-transition" max-width="1400" persistent>
    <v-card class="consultar-agendamentos-modal mx-auto" :loading="carregando ? 'success' : null" :disabled="carregando">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-icon">
            <v-icon size="28" color="white">mdi-calendar-search</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">Consultar Agendamentos</h2>
            <p class="header-subtitle">Busque e gerencie seus agendamentos</p>
          </div>
        </div>
        <v-btn icon dark class="close-btn" @click="fecharModal()">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="unified-content">
        <v-card class="unified-card" flat>
          <div class="filters-section">
            <v-card-text class="filters-content">
              <div class="filter-type-section">
                <h4 class="filter-type-title">Tipo de Busca</h4>
                <v-radio-group v-model="tipoFiltro" row class="filter-type-group">
                  <v-radio
                    v-for="item in opcoesFiltro"
                    :key="item.key"
                    :value="item.key"
                    :label="item.name"
                    color="primary"
                    class="filter-type-radio"
                  />
                </v-radio-group>
              </div>
              <v-row class="filters-grid">
                <v-col cols="12" md="6" lg="4">
                  <div class="filter-field">
                    <label class="filter-label">{{ labelFiltro }}</label>
                    <soi-input
                      v-model="valorFiltro"
                      :type="tipoFiltroComputado"
                      @input="listar()"
                      outlined
                      dense
                      color="primary"
                      hide-details
                      class="filter-input"
                      append-icon="mdi-magnify"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <div class="filter-field">
                    <label class="filter-label">Data do Agendamento</label>
                    <soi-input
                      name="Data"
                      v-model="dataAgendamento"
                      type="date"
                      @input="listar()"
                      outlined
                      dense
                      color="primary"
                      hide-details
                      class="filter-input"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6" lg="2">
                  <div class="filter-field">
                    <label class="filter-label">Itens por Página</label>
                    <soi-select
                      v-model="itens"
                      :items="quantidadeItens"
                      @input="listar()"
                      outlined
                      dense
                      color="primary"
                      hide-details
                      class="filter-input"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6" lg="3" v-if="tipoFiltro === 'idOuNome'">
                  <div class="filter-field">
                    <label class="filter-label">Situação</label>
                    <soi-select
                      v-model="situacaoSelecionada"
                      :items="status"
                      @input="listar()"
                      outlined
                      dense
                      color="primary"
                      hide-details
                      class="filter-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
          <v-divider class="content-divider"></v-divider>
          <div class="table-section">
            <v-data-table
              :headers="colunas"
              :items="listaAgendamentos"
              :loading="carregando ? 'success' : null"
              loading-text="Buscando agendamentos..."
              no-data-text="Nenhum agendamento encontrado!"
              :items-per-page="itens"
              :page.sync="paginaAtual"
              hide-default-footer
              single-select
              class="modern-table"
              :header-props="{ sortIcon: 'mdi-arrow-up' }"
            >
              <template v-slot:item.descricaoPaciente="{ item }">
                <div class="patient-info">
                  <v-avatar size="32" color="primary" class="patient-avatar">
                    <v-icon size="16" color="white">mdi-account</v-icon>
                  </v-avatar>
                  <span class="patient-name">{{ obterNomePaciente(item) }}</span>
                </div>
              </template>

              <template v-slot:item.situacaoAgendamento="{ item }">
                <v-chip
                  :color="obterSituacaoAgendamento(item.situacaoAgendamento).color"
                  small
                  label
                  class="status-chip"
                >
                  <v-icon x-small left>{{ obterSituacaoAgendamento(item.situacaoAgendamento).icon }}</v-icon>
                  {{ obterSituacaoAgendamento(item.situacaoAgendamento).label }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="permiteCadastroAgendamentos"
                      x-small
                      fab
                      color="primary"
                      @click="editarAgendamento(item)"
                      v-bind="attrs"
                      v-on="on"
                      class="action-btn"
                    >
                      <v-icon size="16" color="white">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Agendamento</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
      <div class="pagination-section">
        <v-pagination
          v-model="paginaAtual"
          :length="totalPaginas"
          @input="listar()"
          color="primary"
          class="modern-pagination"
          :total-visible="7"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import { AlertaSimplesErro } from '../../helpers/MensagemHelper';
import Agendamento from '../../models/agendamento/Agendamento';
import { AgendamentoService } from '../../services/AgendamentoService';

export default Vue.component('soi-buscar-agendamento', {
  data() {
    return {
      modalAberto: false,
      carregando: false,
      permiteCadastroAgendamentos: false,
      agendaId: 0,
      linhaSelecionada: [],
      listaAgendamentos: [] as Agendamento[],
      agendamentoService: new AgendamentoService(),
      tipoFiltro: 'idOuNome',
      tipoFiltroNumber: 0,
      valorFiltro: '',
      situacaoSelecionada: '',
      dataAgendamento: '',
      opcoesFiltro: [
        { name: 'Paciente', key: 'idOuNome', type: 'string' },
        { name: 'Compromisso', key: 'descricao', type: 'string' },
      ],
      status: [
        { value: '', text: 'Todos' },
        { value: 'Marcado', text: 'Marcado' },
        { value: 'EmEspera', text: 'Em Espera' },
        { value: 'EmAndamento', text: 'Em Andamento' },
        { value: 'Faltou', text: 'Faltou' },
        { value: 'Finalizado', text: 'Finalizado' },
        { value: 'Cancelado', text: 'Cancelado' },
      ],
      totalPaginas: 0,
      paginaAtual: 1,
      itens: 5,
      quantidadeItens: [
        { value: 5, text: 5 },
        { value: 10, text: 10 },
        { value: 15, text: 15 },
      ],
      colunas: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Tipo de Agendamento',
          value: 'tipoAgendamento',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Paciente ou Compromisso',
          value: 'descricaoPaciente',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Data Agendada',
          value: 'dataAgendamento',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Hora Agendada',
          value: 'horaAgendamento',
        },
        {
          text: 'Situação',
          value: 'situacaoAgendamento',
        },
        {
          text: 'Ações',
          value: 'actions',
        },
      ],
      selectedId: -1,
      opcoesSituacaoAgendamento: [
        {
          value: 0,
          text: 'Marcado',
          label: 'Marcado',
          icon: 'mdi-calendar-check',
          color: '#84b6f4',
        },
        {
          value: 1,
          text: 'EmEspera',
          label: 'Em Espera',
          icon: 'mdi-clock-alert-outline',
          color: '#77dd77',
        },
        {
          value: 2,
          text: 'EmAndamento',
          label: 'Em Andamento',
          icon: 'mdi-progress-check',
          color: '#ffda9e',
        },
        {
          value: 3,
          text: 'Faltou',
          label: 'Faltou',
          icon: 'mdi-close-octagon-outline',
          color: '#ff6961',
        },
        {
          value: 4,
          text: 'Finalizado',
          label: 'Finalizado',
          icon: 'mdi-check-circle-outline',
          color: '#c5c6c8',
        },
        {
          value: 5,
          text: 'Cancelado',
          label: 'Cancelado',
          icon: 'mdi-cancel',
          color: '#ffe180',
        },
      ],
    };
  },
  computed: {
    tipoFiltroComputado() {
      return this.opcoesFiltro.find((x) => x.key === this.tipoFiltro)?.type || 'string';
    },
    descricaoPaciente() {
      return this.listaAgendamentos.map((agendamento: Agendamento) => ({
        agendamentoConsulta: agendamento.agendamentoConsulta ? this.obterNomePaciente(agendamento) : '',
        agendamentoCompromisso: agendamento.agendamentoCompromisso ? agendamento.agendamentoCompromisso.descricao : '',
      }));
    },
    labelFiltro() {
      const itemSelecionado = this.opcoesFiltro.find((item) => item.key === this.tipoFiltro);
      return itemSelecionado ? `Digite um ${itemSelecionado.name} para pesquisar...` : 'Digite o que deseja pesquisar...';
    },
  },
  methods: {
    obterNomePaciente(agendamento: Agendamento) {
      if (agendamento.agendamentoConsulta) {
        const { paciente } = agendamento.agendamentoConsulta;
        if (paciente.usarNomeSocialComoPrincipal && paciente.nomeSocial) {
          return paciente.nomeSocial;
        }
        return paciente.nomeCompleto;
      }
      return agendamento.agendamentoCompromisso ? agendamento.agendamentoCompromisso.descricao : '';
    },
    obterSituacaoAgendamento(situacao) {
      const opcao = this.opcoesSituacaoAgendamento.find((op) => op.text === situacao);
      return {
        color: opcao.color,
        icon: opcao.icon,
        label: opcao.label,
      };
    },
    editarAgendamento(agendamento) {
      this.fecharModal();
      this.$emit('editarAgendamento', agendamento);
    },
    abrirModal(agendaId: number, permiteCadastroAgendamentos: boolean) {
      this.permiteCadastroAgendamentos = permiteCadastroAgendamentos;
      this.agendaId = agendaId;
      this.modalAberto = true;
      this.itens = 5;
      this.listar();
    },
    fecharModal() {
      this.modalAberto = false;
      this.limpaPesquisa();
      this.$emit('atualizarAgenda');
    },
    limpaPesquisa() {
      this.listaAgendamentos = [];
      this.paginaAtual = 1;
      this.valorFiltro = '';
      this.situacaoSelecionada = '';
      this.dataAgendamento = '';
    },
    pesquisa() {
      this.paginaAtual = 1;
      this.listar();
    },
    async listar() {
      this.carregando = true;
      await this.agendamentoService
        .BuscarAgendamentosFiltro(
          this.agendaId,
          this.dataAgendamento || null,
          this.tipoFiltro === 'idOuNome' ? this.valorFiltro : '',
          this.tipoFiltro === 'descricao' ? this.valorFiltro : '',
          this.itens,
          this.paginaAtual,
          this.tipoFiltro === 'idOuNome' && this.situacaoSelecionada ? this.situacaoSelecionada : null,
        )
        .then(
          (res) => {
            this.listaAgendamentos = res.data.itens;
            this.totalPaginas = res.data.totalPaginas;
            this.paginaAtual = res.data.paginaAtual;
            this.listaAgendamentos.forEach((agendamento) => {
              agendamento.dataAgendamento = DateHelper.formataParaDiaMesAno(
                agendamento.dataAgendamento,
              );
            });
          },
          (err) => {
            AlertaSimplesErro('Aviso:', err);
          },
        );
      this.carregando = false;
    },
  },
});
</script>

<style scoped>
/* MODAL PRINCIPAL */
.consultar-agendamentos-modal {
  border-radius: 20px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 80px rgba(0,0,0,0.4) !important;
  background: white !important;
}

/* HEADER MODERNO COM GRADIENTE */
.modal-header {
  background: linear-gradient(135deg, var(--especialidade-primary, #2e4b9d), var(--especialidade-secondary, #1e3a8a)) !important;
  padding: 24px 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  position: relative !important;
  overflow: hidden !important;
}

.header-content {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  position: relative !important;
  z-index: 1 !important;
}

.header-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  color: white !important;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3) !important;
}

.header-subtitle {
  font-size: 14px !important;
  margin: 4px 0 0 0 !important;
  color: rgba(255,255,255,0.9) !important;
  font-weight: 400 !important;
}

.close-btn {
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  position: relative !important;
  z-index: 1 !important;
  transition: all 0.3s ease !important;
}

.close-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  transform: scale(1.05) !important;
}

.unified-card {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
  border: 1px solid #e9ecef !important;
  overflow: hidden !important;
}

/* SEÇÃO DE FILTROS */
.filters-section {
  background: #f8f9fa !important;
  border-bottom: 1px solid #e9ecef !important;
}

.filters-content {
  padding: 24px 32px !important;
}

.filter-type-section {
  margin-bottom: 24px !important;
}

.filter-type-title {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #495057 !important;
  margin-bottom: 12px !important;
}

.filter-type-group {
  margin: 0 !important;
}

.filter-type-radio {
  margin-right: 32px !important;
}

.filter-type-radio .v-label {
  font-weight: 500 !important;
  color: #495057 !important;
}

/* GRID DE FILTROS */
.filters-grid {
  margin: 0 !important;
}

.filter-field {
  margin-bottom: 16px !important;
}

.filter-label {
  display: block !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #6c757d !important;
  margin-bottom: 8px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.filter-input {
  background: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  transition: all 0.3s ease !important;
}

.filter-input:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
}

.filter-input .v-input__control .v-input__slot {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.filter-input .v-input__control .v-input__slot:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

/* SEPARADOR VISUAL */
.content-divider {
  margin: 0 !important;
  border-color: #e9ecef !important;
}

/* SEÇÃO DA TABELA */
.table-section {
  padding: 24px 32px !important;
  background: white !important;
}

.modern-table {
  border-radius: 0 !important;
  overflow: hidden !important;
  box-shadow: none !important;
  border: none !important;
}

.modern-table .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table .v-data-table-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef) !important;
  border-bottom: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.modern-table .v-data-table-header th {
  color: var(--especialidade-primary, #2e4b9d) !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-size: 0.875rem !important;
  padding: 16px 12px !important;
}

.modern-table .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
}

.modern-table .v-data-table__wrapper table tbody tr:hover {
  background: rgba(46, 75, 157, 0.04) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

.modern-table .v-data-table__wrapper table tbody tr td {
  padding: 16px 12px !important;
  border-bottom: 1px solid #f1f3f4 !important;
}

/* INFORMAÇÕES DO PACIENTE */
.patient-info {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

.patient-avatar {
  flex-shrink: 0 !important;
}

.patient-name {
  font-weight: 500 !important;
  color: #495057 !important;
}

/* CHIPS DE STATUS */
.status-chip {
  font-weight: 600 !important;
  border-radius: 20px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

/* BOTÕES DE AÇÃO */
.action-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.2) !important;
}

/* PAGINAÇÃO */
.pagination-section {
  padding: 16px 32px 24px 32px !important;
  background: #f8f9fa !important;
  border-top: 1px solid #e9ecef !important;
  margin-top: 0 !important;
}

.modern-pagination {
  justify-content: center !important;
}

.modern-pagination .v-pagination__item {
  border-radius: 8px !important;
  margin: 0 4px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  transition: all 0.3s ease !important;
}

.modern-pagination .v-pagination__item:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
}

.modern-pagination .v-pagination__item--active {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .consultar-agendamentos-modal {
    margin: 16px !important;
    max-width: calc(100vw - 32px) !important;
  }

  .modal-header {
    padding: 20px 24px !important;
  }

  .header-title {
    font-size: 20px !important;
  }

  .header-subtitle {
    font-size: 13px !important;
  }

  .unified-content {
    padding: 0 24px !important;
  }

  .filters-content {
    padding: 20px 24px !important;
  }

  .table-section {
    padding: 20px 24px !important;
  }

  .pagination-section {
    padding: 12px 24px 20px 24px !important;
  }

  .filter-type-radio {
    margin-right: 16px !important;
  }
}

@media (max-width: 480px) {
  .header-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }

  .header-icon {
    align-self: flex-start !important;
  }

  .filters-grid .v-col {
    margin-bottom: 16px !important;
  }
}

/* ANIMAÇÕES */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.consultar-agendamentos-modal {
  animation: fadeInUp 0.4s ease-out !important;
}

.filters-section {
  animation: fadeInUp 0.5s ease-out 0.1s both !important;
}

.table-section {
  animation: fadeInUp 0.6s ease-out 0.2s both !important;
}

.pagination-section {
  animation: fadeInUp 0.7s ease-out 0.3s both !important;
}
</style>
